import { Action, createReducer, on } from '@ngrx/store';

import * as authActions from './auth.actions';
import { KrosUser } from '../services/auth/kros-user.model';

export interface AuthState {
  currentUser: KrosUser | null;
}

const initialAuthState: AuthState = {
  currentUser: null,
};

const reducer = createReducer(
  initialAuthState,

  on(authActions.setUser,
    (state, payload): AuthState => ({ ...state, currentUser: payload.user })
  ),
  on(authActions.setEmptyUser,
    (state): AuthState => ({ ...state, currentUser: null })
  ),
);

export function authReducer(state: AuthState | undefined, action: Action): AuthState {
  return reducer(state, action);
}
